import React from 'react';
import { DonutChart } from '../../../../../../components/Charts';
import { simplifiedPosition, rangeColor, formRangeColor } from '../../../../../../service/data';
import {
  StyledCard,
  StyledCardHead,
  StyledCardTop,
  StyledCardIdentity,
  StyledCardName,
  StyledCardMeta,
  StyledStatusRow,
  StyledMediaRow,
  StyledStats,
  StyledStat,
  StyledStatValue,
  StyledStatLabel,
} from './squadCardStyled';

const contractLabel = (seasons) => {
  if (seasons == null || seasons === '') return null;
  const n = Number(seasons);
  if (!Number.isFinite(n)) return String(seasons);
  return n === 1 ? '1 season' : `${n} seasons`;
};

const SquadListCard = ({
  player,
  statusIcons,
  isPremium,
  selected,
  onClick,
}) => {
  const position = isPremium && player.second_fav_position
    ? `${simplifiedPosition[player.fav_position] || ''}/${
        simplifiedPosition[player.second_fav_position] || ''
      }`
    : simplifiedPosition[player.fav_position] || '—';
  const media = Array.isArray(player.media_rating)
    ? [...player.media_rating].reverse()
    : [];
  const contract = contractLabel(player.contract_remaining_length);

  return (
    <StyledCard
      type="button"
      $selected={selected}
      $muted={Boolean(player.loanedOut)}
      onClick={onClick}
    >
      <StyledCardHead>
        <StyledCardTop>
          <StyledCardIdentity>
            <StyledCardName>{player.name}</StyledCardName>
            {contract ? <StyledCardMeta>{contract}</StyledCardMeta> : null}
          </StyledCardIdentity>
          {media.length > 0 ? (
            <StyledMediaRow>
              {media.map((item, itemIndex) => (
                <DonutChart
                  key={`${item}${itemIndex}`}
                  index={itemIndex + 1}
                  arcSize={item}
                  small
                />
              ))}
            </StyledMediaRow>
          ) : null}
        </StyledCardTop>
        {statusIcons ? <StyledStatusRow>{statusIcons}</StyledStatusRow> : null}
      </StyledCardHead>
      <StyledStats>
        <StyledStat>
          <StyledStatValue>{position}</StyledStatValue>
          <StyledStatLabel>Position</StyledStatLabel>
        </StyledStat>
        <StyledStat>
          <StyledStatValue>{player.age ?? '—'}</StyledStatValue>
          <StyledStatLabel>Age</StyledStatLabel>
        </StyledStat>
        <StyledStat>
          <StyledStatValue $color={rangeColor[player.ratingValue]}>
            {player.ratingValue || '—'}
          </StyledStatValue>
          <StyledStatLabel>Rating</StyledStatLabel>
        </StyledStat>
        <StyledStat>
          <StyledStatValue $color={rangeColor[player.potentialValue]}>
            {player.potentialValue || '—'}
          </StyledStatValue>
          <StyledStatLabel>Potential</StyledStatLabel>
        </StyledStat>
        <StyledStat>
          <StyledStatValue $color={formRangeColor[player.form]}>
            {player.form || '—'}
          </StyledStatValue>
          <StyledStatLabel>Fitness</StyledStatLabel>
        </StyledStat>
      </StyledStats>
    </StyledCard>
  );
};

export default SquadListCard;
